import { render, staticRenderFns } from "./StarterHeader.vue?vue&type=template&id=b54f4702&"
import script from "./StarterHeader.vue?vue&type=script&lang=js&"
export * from "./StarterHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports